/**
 * Known-flags for counts that the brief composers take as optional inputs
 * (blueprint §6.2, §7 C10/C13/X5). A count that is missing or failed must
 * reach a composer as `undefined`, never 0: a fabricated 0 renders as a
 * false all-clear ("No resources have drifted from your baseline.").
 */

/** Pure number check: NaN and non-numbers are unknown. */
function asCount(v: unknown): number | undefined {
  return typeof v === 'number' && Number.isFinite(v) ? v : undefined
}

/**
 * Active-drift count from the dashboard `Metrics` block (PascalCase or
 * camelCase). `activeDriftsKnown` is true only when the payload carried a
 * numeric `ActiveAlerts` / `activeAlerts`.
 */
export function readActiveDrifts(
  metrics: Record<string, unknown> | null | undefined,
): { activeDrifts: number; activeDriftsKnown: boolean } {
  const n = asCount(metrics?.ActiveAlerts) ?? asCount(metrics?.activeAlerts)
  return { activeDrifts: n ?? 0, activeDriftsKnown: n !== undefined }
}

/**
 * Open-violation count is trustworthy when the violation summary query
 * succeeded with a payload, or the violations list query succeeded (the
 * fallback count). A loading, failed or 404 (null) source is unknown.
 */
export function openViolationsKnown(q: {
  summarySuccess: boolean
  summaryPresent: boolean
  violationsSuccess: boolean
}): boolean {
  return (q.summarySuccess && q.summaryPresent) || q.violationsSuccess
}
